import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { View, Text, Image, Pressable } from 'react-native-web';

import styles from './styles';

const propTypes = {
  page: PropTypes.number,
  imageUrl: PropTypes.string,
  selected: PropTypes.bool,
  onPress: PropTypes.func,
  disabled: PropTypes.bool,
};

const defaultProps = {
  page: undefined,
  imageUrl: undefined,
  selected: false,
  onPress: undefined,
  disabled: false,
};

/**
 * Page number for PageButton component
 *
 * @param {Object} props
 * @param {number | undefined} props.page
 * @param {string | undefined} props.imageUrl
 * @param {boolean} props.selected
 * @param {boolean} props.disabled
 * @returns {JSX.Element} PageNumber component
 */
const PageButton = ({ page, imageUrl, selected, disabled, onPress }) => {
  const [hovered, setIsHovered] = useState(false);

  if (!page && !imageUrl) {
    return (
      <View style={[styles.buttonContainer, styles.textButton]}>
        <Text>...</Text>
      </View>
    );
  }

  const buttonStyles = [
    styles.buttonContainer,
    ...(hovered || selected ? [styles.hover] : []),
    ...(disabled ? [styles.disabled] : []),
  ];

  const onHoverIn = () => setIsHovered(true);
  const onHoverOut = () => setIsHovered(false);

  return (
    <Pressable
      onHoverIn={onHoverIn}
      onHoverOut={onHoverOut}
      style={buttonStyles}
      disabled={disabled}
      onPress={onPress}
    >
      {!page && imageUrl ? (
        <Image source={imageUrl} style={styles.iconButton} />
      ) : (
        <Text style={styles.textButton}>{page}</Text>
      )}
    </Pressable>
  );
};

PageButton.propTypes = propTypes;
PageButton.defaultProps = defaultProps;

export default PageButton;
